import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
	mode: "history",
	routes: [{
		path: "/",
		hide: true,
		redirect: "/family",
	},
	{
		path: "/portal",
		hide: true,
		redirect: "/family",
	},
	{
		path: "/family",
		name: "用户端",
		hide: false,
		requireAuth: false,
		meta: { requireAuth: false },
		component: (resolve) =>
			require(["./components/family/FamilyApp.vue"], resolve),
	},
	{
		path: "/family/login",
		name: "用户登录",
		hide: true,
		meta: { requireAuth: false },
		component: (resolve) =>
			require(["./components/family/FamilyLogin.vue"], resolve),
	},
	{
		path: "/family/register",
		name: "用户注册",
		hide: true,
		meta: { requireAuth: false },
		component: (resolve) =>
			require(["./components/family/FamilyRegister.vue"], resolve),
	},
	{
		path: "/family/request",
		name: "发起陪护",
		hide: true,
		meta: { requireAuth: false, familyAuth: true },
		component: (resolve) =>
			require(["./components/family/FamilyRequest.vue"], resolve),
	},
	{
		path: "/family/order/:id/review",
		name: "评价护工",
		hide: true,
		meta: { requireAuth: false, familyAuth: true },
		component: (resolve) =>
			require(["./components/family/FamilyOrderReview.vue"], resolve),
	},
	{
		path: "/family/order/:id",
		name: "订单详情",
		hide: true,
		meta: { requireAuth: false, familyAuth: true },
		component: (resolve) =>
			require(["./components/family/FamilyOrderDetail.vue"], resolve),
	},
	{
		path: "/family/caregiver/:id",
		name: "护工详情",
		hide: true,
		meta: { requireAuth: false },
		component: (resolve) =>
			require(["./components/family/FamilyCaregiverDetail.vue"], resolve),
	},
	{
		path: "/family/settings",
		name: "账号与安全",
		hide: true,
		meta: { requireAuth: false, familyAuth: true },
		component: (resolve) =>
			require(["./components/family/FamilyUserSettings.vue"], resolve),
	},
	{
		path: "/family/patients",
		name: "陪护人档案",
		hide: true,
		meta: { requireAuth: false, familyAuth: true },
		component: (resolve) =>
			require(["./components/family/FamilyPatientArchive.vue"], resolve),
	},
	{
		path: "/caregiver",
		name: "护工端",
		hide: false,
		requireAuth: false,
		meta: { requireAuth: false },
		component: (resolve) =>
			require(["./components/caregiver/CaregiverApp.vue"], resolve),
	},
	{
		path: "/login",
		name: "管理端登录",
		hide: true,
		meta: { requireAuth: false, pageTitle: "运营调度后台" },
		component: (resolve) =>
			require(["./components/login/login.vue"], resolve),
	},
	{
		path: "/register",
		hide: true,
		redirect: "/login",
	},
	{
		path: "/index",
		name: "首页",
		hide: false,
		requireAuth: true,
		redirect: "/dispatch/orders",
		component: (resolve) => require(["./common/home.vue"], resolve),
		children: [
		{
			path: "/dispatch/console",
			name: "调度控制台",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "调度控制台" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchConsole.vue"], resolve),
		},
		{
			path: "/dispatch/orders",
			name: "待指派订单池",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "待指派订单池" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchOrderPool.vue"], resolve),
		},
		{
			path: "/dispatch/caregivers",
			name: "护工档案",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "护工档案" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchCaregivers.vue"], resolve),
		},
		{
			path: "/dispatch/hospitals",
			name: "医院配置",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "医院配置" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchHospitals.vue"], resolve),
		},
		{
			path: "/dispatch/family-users",
			name: "用户管理",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "用户管理" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchFamilyUsers.vue"], resolve),
		},
		{
			path: "/dispatch/accounts",
			name: "账号管理",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "账号管理" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchAccountManage.vue"], resolve),
		},
		{
			path: "/dispatch/kyc",
			name: "KYC审核",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "KYC 审核", placeholderTitle: "KYC 审核", placeholderDesc: "护工实名认证与资质证书审核", placeholderIcon: "safety-certificate" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchPlaceholder.vue"], resolve),
		},
		{
			path: "/dispatch/monitor",
			name: "履约监控",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "履约监控", placeholderTitle: "履约监控", placeholderDesc: "护工打卡记录与服务过程跟踪", placeholderIcon: "eye" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchPlaceholder.vue"], resolve),
		},
		{
			path: "/dispatch/finance",
			name: "财务对账",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "财务对账", placeholderTitle: "财务对账", placeholderDesc: "订单结算与护工提现对账", placeholderIcon: "account-book" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchPlaceholder.vue"], resolve),
		},
		{
			path: "/dispatch/dispute",
			name: "纠纷仲裁",
			hide: false,
			requireAuth: true,
			meta: { pageTitle: "纠纷仲裁", placeholderTitle: "纠纷仲裁", placeholderDesc: "家属投诉与纠纷处理", placeholderIcon: "alert" },
			component: (resolve) =>
				require(["./components/dispatch/DispatchPlaceholder.vue"], resolve),
		},
		{
			path: "/dashboard",
			name: "仪表板",
			hide: false,
			requireAuth: true,
			component: (resolve) =>
				require(["./components/dashboard/Dashboard.vue"], resolve),
		},
		{
			path: "/system",
			name: "账号管理",
			hide: false,
			requireAuth: true,
			component: (resolve) =>
				require(["./components/system/SystemManagement.vue"], resolve),
		},
		{
			path: "/dept",
			name: "部门管理",
			hide: false,
			requireAuth: true,
			component: (resolve) =>
				require(["./components/department/dept.vue"], resolve),
		},
		{
			path: "/menuRole",
			name: "菜单配置",
			hide: false,
			requireAuth: true,
			component: (resolve) =>
				require(["./components/menumanage/MenuConfig.vue"], resolve),
		},
		{
			path: "/staff",
			name: "员工管理",
			hide: false,
			requireAuth: true,
			component: (resolve) =>
				require(["./components/staff/staff.vue"], resolve),
		},
		],
	}, {
		path: "/404",
		name: "页面不见了",
		hide: true,
		component: (resolve) =>
			require(["./components/error/page404.vue"], resolve),
	}, {
		path: "*", // 此处需特别注意置于最底部
		redirect: "/404",
		hide: true,
	},
	],
});
